import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link, graphql } from 'gatsby';
import { prefix } from '../i18n-config';
import { Trans, withI18n } from '@lingui/react';
import _ from 'lodash';

import InquiryForm from '../components/InquiryForm';
import NewsLetterForm from '../components/NewsLetterForm';
import Facebook from '../components/img/Facebook';
import Instagram from '../components/img/Instagram';
import Twitter from '../components/img/Twitter';
import Youtube from '../components/img/Youtube';

import LogoPrecogStudio from '../../static/branding/precog_wordmark.png';
import ServicePopup from '../components/ServicePopup';


class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGlitching: false,
      screenSize: {},
      scrollY: 0,
      activeServiceItem: null,
      animateIntro: false,
      animateServices: false,
      animateContactUs: false,
      introHeaderStyles: {},
      introBGStyle: {},
      contactSectionStyles: {},
      newsletterSectionStyles: {},
      spaceWrapperStyle: {},
      BGStyles: {},
      formMessage: '',
      formNewsletterMessage: '',
      showFormMessage: false,
      showNewsletterMessage: false,
      showV2: true
    };
    const { pageContext, data } = this.props;
    const lang = pageContext.lang;
    const content = data.dataJson.index[lang];
    this.langPrefix = prefix(pageContext.lang);

    this.introRef = React.createRef();
    this.servicesRef = React.createRef();
    this.newsletterRef = React.createRef();
    this.newsletterHeaderRef = React.createRef();
    this.newsletterBoxRef = React.createRef();
    this.contactUsRef = React.createRef();
    this.spaceWrapperRef = React.createRef();

    this.introHeaderLineRef = React.createRef();
    this.newsletterHeaderLineRef = React.createRef();
    this.contactUsHeaderLineRef = React.createRef();

    this.sections = content.sections;
    this.sections.splice(this.sections.length - 1, 0, {
      id: 'extra'
    });
    this.scrollContainer = null;
    this.isIpad = false;
  }

  componentDidMount() {
    this.isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
    this.scrollContainer = document.querySelector('.main-wrapper');
    window.requestAnimationFrame = window.requestAnimationFrame
                                  || window.mozRequestAnimationFrame
                                  || window.webkitRequestAnimationFrame
                                  || window.msRequestAnimationFrame
                                  || function(f){setTimeout(f, 1000/60)}

    window.addEventListener('scroll', () => requestAnimationFrame(this.handleScroll));
    window.addEventListener('resize', () => this.resizeHandler(), false);

    this.resizeHandler();
    this.handleScroll();
  }

  componentWillUnmount() {
  }

  handleScroll = () => {
    const  { screenSize, showV2 } = this.state;
    const currentPos = window.scrollY;
    const viewportHeight = window.innerHeight;
    const visibleArea = currentPos + viewportHeight;

    if (!this.newsletterRef) {
      return
    }

    const newsletterRect = this.newsletterRef.current.getBoundingClientRect();
    const newsletterHeaderRect = this.newsletterHeaderRef.current.getBoundingClientRect();
    const newsletterBoxRect = this.newsletterBoxRef.current.getBoundingClientRect();
    const contactUsRect = this.newsletterRef.current.getBoundingClientRect();
    const spaceWrapperRect = this.spaceWrapperRef.current.getBoundingClientRect();

    // console.log(currentPos);

    // Newsletter
    if (newsletterRect.top + currentPos < visibleArea && screenSize.width > 600) {
      const startingPoint = (newsletterRect.top + currentPos) - newsletterRect.height;
      const boxXStartPoint = startingPoint + 20;
      const boxYStartPoint = startingPoint + (newsletterRect.height * .99);
      const headerXStartPoint = startingPoint + (newsletterRect.height * 1.01);
      const headerYStartPoint = startingPoint + (newsletterRect.height * .8);
      const opacityStartPoint = startingPoint + (newsletterRect.height * 1.78);
      const boxMaxXPos = (newsletterRect.width - newsletterBoxRect.width) - 15;
      const headerMaxXPos = (newsletterRect.width - (newsletterBoxRect.width + newsletterHeaderRect.width) - 50);
      const allowHeaderToMoveToLeft = newsletterRect.width > (newsletterBoxRect.width + newsletterHeaderRect.width) - 70;

      this.setState({
        newsletterSectionStyles: {
          header: {
            opacity: currentPos > opacityStartPoint ? Math.min(1, 1 - ((currentPos - opacityStartPoint) / 250)) : 1,
            transform: `translate(${currentPos > headerXStartPoint && allowHeaderToMoveToLeft ? Math.min(headerMaxXPos, 0 + (currentPos - headerXStartPoint)) : 0}px, ${currentPos > headerYStartPoint ? Math.max(0, 0 + (currentPos - headerYStartPoint)) : 0}px)`
          },
          box: {
            pointerEvents: currentPos > opacityStartPoint ? 'none' : null,
            opacity: currentPos > opacityStartPoint ? Math.min(1, 1 - ((currentPos - opacityStartPoint) / 250)) : 1,
            transform: `translate(${currentPos > boxXStartPoint ? Math.min(boxMaxXPos, 0 + (currentPos - boxXStartPoint)) : 0}px, ${currentPos > boxYStartPoint ? Math.max(0, 0 + (currentPos - boxYStartPoint)) : 0}px)`
            // left: `${currentPos > boxXStartPoint ? Math.min(boxMaxXPos, 0 + (currentPos - boxXStartPoint)) : 0}px`,
            // top: `${currentPos > boxYStartPoint ? Math.max(0, 0 + (currentPos - boxYStartPoint)) : 0}px`
          }
        }
      })
    }

    // Contact Us
    if (contactUsRect.top + currentPos < visibleArea && screenSize.width > 600) {
    
      const startingPoint = (contactUsRect.top + currentPos) - contactUsRect.height;
      let headerStartPoint = startingPoint + (contactUsRect.height * 1.5);
      let containerXStartPoint = startingPoint + (contactUsRect.height * 1.7);
      let containerYStartPoint = startingPoint + (contactUsRect.height * .3) + spaceWrapperRect.height;
      let handsXStartPoint = startingPoint + (contactUsRect.height * 1.99);
      let formYStartPoint = startingPoint + (contactUsRect.height * 2.1);

      if (showV2) {
        handsXStartPoint = startingPoint + (contactUsRect.height * 2.55);
        formYStartPoint = startingPoint + (contactUsRect.height * 2.55);
      }
      
      let containerTransform = `translate(${currentPos > containerXStartPoint ? Math.min(0, -180 - (containerXStartPoint - currentPos)) : -180}px, ${currentPos > containerYStartPoint ? Math.min(0, -546 - (containerYStartPoint - currentPos)) : -546}px)`;

      if (screenSize.width < 900) {
        handsXStartPoint = startingPoint + (contactUsRect.height * .69);
        formYStartPoint = startingPoint + 200;
        containerTransform = `translate(0, ${Math.max(-100, 0 + (startingPoint - currentPos))}px)`;
      }

      formYStartPoint -= 100;

      this.setState({
        contactSectionStyles: {
          header: {
            transform: `translate(0, ${currentPos > headerStartPoint ? Math.min(-50, -350 + (currentPos - headerStartPoint)) : -350}px)`
          },
          container: {
            marginTop: `${currentPos > containerXStartPoint ? Math.max(0, 550 - (currentPos - containerXStartPoint)) : 550}px`,
            transform: containerTransform
          },
          cyborgHeadSize: {
						// width: (currentPos > 2100 ? Math.min(35, 45 - (currentPos - 2100)) : 35) + '%'
          },
          cyborgHeadCircle: {
            boxShadow: `0 0 0 10px ${currentPos > formYStartPoint ? '#fff' : 'transparent'}`
          },
          cyborgLeftHand: {
            transform: `translate(${currentPos > handsXStartPoint ? Math.min(155, 0 + (currentPos - handsXStartPoint)) : 0}px, 0)`
          },
          cyborgRightHand: {
            transform: `translate(${currentPos > handsXStartPoint ? Math.max(-155, 0 - (currentPos - handsXStartPoint)) : 0}px, 0)`
          },
          formContainer: {
            opacity: currentPos > formYStartPoint ? Math.min(1, 0.5 + ((currentPos - formYStartPoint) / 250)) : 0.5,
            transform: `translate(0, ${currentPos > formYStartPoint ? Math.max(0, 170 - (currentPos - formYStartPoint)) : 170}px)`
          }
        }
      });
    }

    // IPAD SUPPORT LANDSCAPE
    if (this.isIpad && screenSize.width >= 1024) {
      // Space Wrapper
      if (spaceWrapperRect.top + currentPos < visibleArea) {
        this.setState({
          spaceWrapperStyle: {
            backgroundPositionX: `${Math.min(0, (spaceWrapperRect.top + currentPos) - visibleArea)}px`
          }
        });
      }

      this.setState({
        introBGStyle: {
          backgroundPositionX: `${Math.max(0, screenSize.width - (currentPos))}px`
        }
      })
    }

    this.setState({
      scrollY: currentPos,
      heroLogoStyles: {
        transform: `translate(0, ${Math.max(-1000, 0 - currentPos)}px)`,
        opacity: Math.min(1, 1 - (currentPos / 250))
      },
      introHeaderStyles: {
        marginTop: Math.max(0, 300 - currentPos) + 'px'
      },
      BGStyles: {
        hexagon: {
          transform: `translate(${screen.width > 600 && currentPos > 0 ?  Math.max(-1000, -(currentPos * .2)) : 0}px, ${currentPos > 0 ? Math.max(-1000, -(currentPos * .2)) : 0}px)`
        },
        hexagon2: {
          transform: `translate(${screen.width > 600 && currentPos > 0 ? Math.max(-1000, -(currentPos * .3)) : 0}px, ${currentPos > screen.height ? Math.max(-1000, -(currentPos * .3)) : 0}px)`
        },
        oblique: {
          transform: `translate(0, ${currentPos > 0 ? Math.min(10000, currentPos * .35) : 0}px)`
        }
      },
      introHeaderLineStyle: {
        width: this.getSectionScrollProgress(viewportHeight, this.introRef)+'%'
      },
      // servicesHeaderLineStyle: {
      //   width: this.getSectionScrollProgress(viewportHeight, this.servicesRef)+'%'
      // },
      newsletterHeaderLineStyle: {
        width: this.getSectionScrollProgress(viewportHeight, this.newsletterRef, true)+'%'
      },
      contactUsHeaderLineStyle: {
        width: this.getSectionScrollProgress(viewportHeight, this.contactUsRef, false, true)+'%'
      }
    });
  }

  getSectionScrollProgress = (viewportHeight, section, isNewsLetter, isContact) => {
    const sectionRect = section.current.getBoundingClientRect();
    let sectionHeight = sectionRect.height;
    sectionHeight = sectionHeight + (isNewsLetter ? this.spaceWrapperRef.current.getBoundingClientRect().height : 0);
    sectionHeight = sectionHeight + (isContact ? sectionHeight/2 : 0);
    const progress = Math.min(100, (((viewportHeight + window.scrollY) - (sectionRect.top + window.scrollY)) / sectionHeight) * 100);

    return progress;
  }

  moveToSection = (section) => {
    const targetElem = document.querySelector(`#${section}`);

    targetElem.scrollIntoView({
        behavior: 'smooth',
    });
  }

  showServiceDescription = (serviceItem) => {
    this.setState({
      activeServiceItem: serviceItem
    });
  }

  hideServiceDescription = () => {
    this.setState({
      activeServiceItem: null
    });
  }

  resizeHandler = () => {
    this.setState({
      screenSize: {
        width: window.innerWidth,
        height: window.innerHeight
      },
      showV2: window.innerWidth >= 900
    });

    this.handleScroll();
  }

  handleNewsletterSubmit = (message) => {
    this.setState({
      formNewsletterMessage: message,
      showNewsletterMessage: true
    })
  }

  handleFormSubmit = (message) => {
    this.moveToSection('contact-form-submit');

    this.setState({
      formMessage: message,
      showFormMessage: true
    })
  }

  handleResetContactForm = () => {
    this.setState({
      formMessage: '',
      showFormMessage: false
    });
  }

  renderHero = (data) => {
    const { heroLogoStyles } = this.state;
    const heroData = data.content.hero;

    return <div key={data.id} className="hero-wrapper section-item">
      <img src={LogoPrecogStudio} alt="Precog Studio" className="logo" style={heroLogoStyles} />
      <div className="video-wrapper">
        <iframe src={heroData.videoUrl} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen></iframe>
      </div>
      <div className="arrow" onClick={() => this.moveToSection('who-we-are')}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }

  renderIntro = (data) => {
    const { animateIntro, introHeaderStyles, introHeaderLineStyle, introBGStyle } = this.state;
    const introData = data.content.intro;

    return <div key={data.id} className={`intro-wrapper section-item ${animateIntro ? 'animate' : ''}`} ref={this.introRef} style={introBGStyle}>
      <span id="who-we-are" className="scroll-target"/>
      <div className="container">
        <div>
          <h4 style={introHeaderStyles}>
            {data.title}
            <span className="line-wrapper">
              <span className="line" ref={this.introHeaderLineRef} style={introHeaderLineStyle}/>
            </span>
          </h4>
          <div dangerouslySetInnerHTML={{ __html: introData.description }} />
          <div className="spacer-100" />
         </div>
      </div>
    </div>
  }

  /*
  <div className="img-wrapper">
    <img src={introData.images[0]} />
  </div>
  */

  renderServiceDescriptionBox = () => {
    const { activeServiceItem } = this.state;

    return <ServicePopup serviceItem={activeServiceItem} onClose={this.hideServiceDescription} />
  }

  renderServices = (data) => {
    const { animateServices, activeServiceItem, servicesHeaderLineStyle } = this.state;
    const servicesData = data.content.services;

    return <div key={data.id} className={`services-wrapper section-item ${animateServices ? 'animate' : ''}`} ref={this.servicesRef}>
      <span id="our-services" className="scroll-target"/>
      <div className="container">
        <h4>
          {data.title}
          <span className="line-wrapper">
            <span className="line" style={servicesHeaderLineStyle} />
          </span>
        </h4>
        {activeServiceItem && this.renderServiceDescriptionBox()}
        <div className="services-list">
          { 
            servicesData.map((service, i) => {
            return <div key={i} className="service-item">
              <span className="title">{service.title}</span>
              <img src={service.imageUrl} alt={service.title} />
              <div className="info-wrapper">
                <h5>{service.title}</h5>
                <div className="description" dangerouslySetInnerHTML={{ __html: service.excerpt }} />
                <button className="show-more" onClick={() => this.showServiceDescription(service)}>Show More</button>
              </div>
            </div>
           })}
        </div>
      </div>
    </div>
  }

  renderExtraRow = () => {
    const { spaceWrapperStyle } = this.state;
    return <div key={5} ref={this.spaceWrapperRef} className={`space-wrapper section-item`} style={spaceWrapperStyle}>
      <div className="container">
        <div className="spacer-100" />
        <div className="spacer-100" />
        <div className="spacer-100" />
      </div>
    </div>
  }

  renderNewsletter = () => {
    const { animateServices, newsletterSectionStyles, formNewsletterMessage, showNewsletterMessage, newsletterHeaderLineStyle } = this.state;

    return <div key={6} className={`newsletter-wrapper section-item ${animateServices ? 'animate' : ''}`} >
      <span id="subscribe" className="scroll-target"/>
      <div className="container" ref={this.newsletterRef}>
        <h4
          ref={this.newsletterHeaderRef}
          style={newsletterSectionStyles.header}
        >
          Newsletter Subscription
          <span className="line-wrapper" ref={this.newsletterHeaderLineRef}>
            <span className="line" style={newsletterHeaderLineStyle} />
          </span>
        </h4>

        <div className="box-wrapper" ref={this.newsletterBoxRef} style={newsletterSectionStyles.box}>
          {!showNewsletterMessage && <>
            <h3>SUBSCRIBE TO OUR NEWSLETTER FOR UPDATES</h3>
            <NewsLetterForm onFormSubmit={(e) => this.handleNewsletterSubmit(e)}/>
          </>}
          {showNewsletterMessage && <div className="form-wrapper _on_success">
            <div className="message-wrapper" dangerouslySetInnerHTML={{ __html: formNewsletterMessage }} />
          </div>}
          <h3>FOLLOW US AND STAY CONNECTED</h3>
          <div className="social-links-wrapper">
            <div className="social-links">
              <a className="social-links__item _instagram" href="http://instagram.com/precog.studio" target="_blank"><Instagram /></a>
              <a className="social-links__item _youtube" href="/youtube" target="_blank"><Youtube /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  renderContactUs = (data) => {
    const { animateContactUs, contactSectionStyles, formMessage, showFormMessage, showV2, contactUsHeaderLineStyle } = this.state;
    const contactData = data.content.contact;

    return <div key={data.id} className={`contact-wrapper section-item ${animateContactUs ? 'animate' : ''} ${showV2 ? 'on-v2' : ''} ${showFormMessage ? 'on-form-message' : ''}`}>
      <span id="contact-us" className="scroll-target"/>
      <span id="contact-form-submit" className="scroll-target"/>
      <div className="container" ref={this.contactUsRef} >
        <h4 style={contactSectionStyles.header}>
          {data.title}
          <span className="line-wrapper">
            <span className="line" style={contactUsHeaderLineStyle}/>
          </span>
        </h4>
        <div className="content-wrapper" style={contactSectionStyles.container}>
            <div className="cyborg">

              <div className="head" style={contactSectionStyles.cyborgHeadSize}>
                <span className="circle" style={contactSectionStyles.cyborgHeadCircle}/>
                <img src="/cyborg/cyborg_head.png" alt="" />
              </div>
              {!showFormMessage && <>
                <img className="l-hand" src="/cyborg/cyborg_hand_L_1.png" alt="" style={contactSectionStyles.cyborgLeftHand} />
                <img className="r-hand" src="/cyborg/cyborg_hand_R_1.png" alt="" style={contactSectionStyles.cyborgRightHand} />
              </>}
              {showFormMessage && <>
                <img className="l-hand" src="/cyborg/cyborg_hand_L_2.png" alt="" style={contactSectionStyles.cyborgLeftHand} />
                <img className="r-hand" src="/cyborg/cyborg_hand_R_2.png" alt="" style={contactSectionStyles.cyborgRightHand} />
              </>}
            </div>

            {!showFormMessage && <div className="container" style={contactSectionStyles.formContainer}>
              <div dangerouslySetInnerHTML={{ __html: contactData.description }} />
              <br />
              <InquiryForm onFormSubmit={(e) => this.handleFormSubmit(e)} />
            </div>}
            {showFormMessage && <div className="container">
              <div className="message-wrapper" dangerouslySetInnerHTML={{ __html: formMessage }} />
              <button className="button" onClick={this.handleResetContactForm}>Send another message</button>
            </div>}
        </div>
      </div>
    </div>
  }
  
  render() {
    const { location } = this.props;
    const { BGStyles } = this.state;
    const lang = this.langPrefix;

    return (
      <div className="page front-page">
        <Helmet defaultTitle="Precog Studio" titleTemplate="%s - a Montreal based production house for interactive media, marketing and films">
          <meta name="og:type" content="website" />
          <meta name="og:site_name" content="Precog Studio" />
          <title>Precog Studio</title>
          <link
            rel="canonical"
            href={`https://precog.studio${location.pathname}`}
          />
          <html lang={lang} />
          <meta name="description" content="Precog Studio is a Montreal based production house for interactive media, marketing and films." />
          <meta name = "viewport" content = "width=device-width, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no" />
        </Helmet>
        <div>
          <div className="bg-wrapper">
            <div className="bg _hexagon" style={BGStyles.hexagon}/>
            <div className="bg _hexagon _2" style={BGStyles.hexagon2}/>
            <div className="bg _oblique" style={BGStyles.oblique}/>
          </div>
          { this.sections && this.sections.map(section => {
            if (section.id == 'hero') {
              return this.renderHero(section);
            } else if (section.id == 'intro') {
              return this.renderIntro(section);
            } else if (section.id == 'services') {
              return ''; //this.renderServices(section);
            } else if (section.id == 'subscribe') {
              return this.renderNewsletter()
            } else if (section.id == 'extra') {
              return this.renderExtraRow()
            } else if (section.id == 'contact') {
              return this.renderContactUs(section)
            }
          })}
        </div>
      </div>
    );
  }
}

export default withI18n()(Home);

export const query = graphql`
  query {
    dataJson {
      index {
        en {
          seo,
          intro
          sections {
            title,
            id,
            content {
              hero {
                text,
                videoUrl
              },
              intro {
                description
                images
              },
              services {
                title,
                imageUrl,
                excerpt,
                description
              },
              subscribe {
                description
              },
              contact {
                description
              }
            }
          }
        },
        fr {
          seo,
          intro
          sections {
            title,
            id,
            content {
              hero {
                text,
                videoUrl
              },
              intro {
                description
                images
              },
              services {
                title,
                imageUrl,
                excerpt,
                description
              },
              subscribe {
                description
              },
              contact {
                description
              }
            }
          }
        }
      }
    }
  }
`;
